import React, { useState } from 'react';
import { AppBar, Box, Button, Grid, IconButton, InputAdornment, makeStyles, TextField, Toolbar, Typography } from '@material-ui/core';
import { http } from '../../network';
import { toast } from 'react-toastify';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { useNavigate, useParams } from 'react-router';
import AppBarComp from '../../components/AppBar';
import { useSearchParams } from 'react-router-dom';


const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
            background: 'radial-gradient(circle, rgba(187,187,187,1) 2%, rgba(112,114,116,1) 100%)',
        },
        container: {
            height: '100%',
            alignItems: 'center'
        },
        qWidth: {
            // width: '50%',
            marginBottom: 8
        },
        floatingLabelFocusStyle: {
            color: theme.palette.main
        },
        saveBtn: {
            // marginRight: '25%'
        }
    }
});

const NewPassword = () => {
    const classes = useStyles();
    const [showPassword, setShow] = useState(false)
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirm] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const token = searchParams.get('token')

    const sendLink = async () => {
        setLoading(true)
        const body = { newPassword: password, confirmPassword }
        try {
            const res = await http.post(`/password/reset/${token}`, body)
            toast(res?.data?.message)
            navigate('/login')
        } catch (error) {
            toast(error?.response?.data?.error || 'User Not found')
        } finally {
            setLoading(false)
        }

    }

    return (<>
        <AppBarComp />
        <Box component={"div"} className={classes.root}>
            <Grid container direction='column' justifyContent='center' alignItems='center' className={classes.container}>
                <Grid item >
                    <Grid item className={classes.qWidth}>
                        <TextField
                            autoComplete='off'
                            fullWidth label="Password" variant='outlined'
                            type={showPassword ? "text" : "password"}
                            onChange={(e) => setPassword(e.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => setShow(!showPassword)}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Grid>
                    <Grid item className={classes.qWidth}>
                        <TextField
                            autoComplete='off'
                            fullWidth label="Confirm Password" variant='outlined'
                            type={"password"}
                            onChange={(e) => setConfirm(e.target.value)}
                        />
                    </Grid>
                </Grid>
                <Grid item >
                    <Button disabled={!password || (confirmPassword !== password) || loading} onClick={sendLink} loading variant='contained' color="primary">
                        Save
                    </Button>
                </Grid>
            </Grid>
        </Box>
    </>
    )
}

export default NewPassword